import React, { useEffect, useState } from "react";
import api from "utils/apiService";

import TableDemo from "components/TableDemo";
import OffersColumn from "data/OffersColumn";
import OfferFilter from "./components/OfferFilter";
import { useSearchParams } from "react-router-dom";

const Index = () => {
  const [data, setData] = useState({ data: [], pagination: { totalDocs: 0 } });
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page") || 1;
  const search = searchParams.get("search") || "";
  const status = searchParams.get("status") || "";

  const fetchData = async () => {
    try {
      const res = await api.get(
        `/offers/getOffersByAdmin?page=${page}${search && `&name=${search}`}${
          status && `&status=${status}`
        }`
      );

      if (res.error) {
        console.error("API Error:", res.error);
      } else {
        setData({
          data: res?.data || [],
          pagination: res?.pagination || { totalDocs: 0 },
        });
      }
    } catch (error) {
      console.error("Unexpected Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, search, status]);
  return (
    <section className="mt-3">
      <TableDemo
        data={data?.data}
        columns={OffersColumn(fetchData)}
        title="العروض"
        totalCount={data?.pagination?.totalDocs}
        loading={loading}
        extraComponent={<OfferFilter />}
        searchExtra="name"
      />
    </section>
  );
};

export default Index;
